import React from 'react'
import { Box } from '@mui/material'

/** Dotted box used for uploads */
export default function DottedBox(props: IDottedBoxProps) {
  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px dashed #A4AAFF',
        borderRadius: '4px',
        padding: '30px 35px 30px 30px',
        width: '320px',
        height: '187px'
      }}
    >
      {props.children}
    </Box>
  )
}

interface IDottedBoxProps {
  children: React.ReactNode
}
